import React from 'react';
import { Icon, IconNames } from 'components/atoms';
import { InfoPlaceholder } from 'constants/common';
import { Moment } from 'moment';
import Countdown from 'react-countdown';
import { GameType } from 'types/tables';
import {
  Wrapper,
  TableDescription,
  Item,
  ItemInner,
  ItemLabel,
  ItemValue,
  ControlsWrapper,
  Buttons,
  UserButton,
  PowerButton,
  StageCountdown,
  StageText,
  ItemBox,
  ItemText,
  JPDate,
  ShuffleButton,
} from './styles';

export interface IProps {
  tableId: string;
  roundId?: string;
  dealerName: string;
  isChangeDealerDisabled: boolean;
  onChangeDealerClick: () => void;
  onCloseTableClick: () => void;
  className?: string;
  stage: boolean;
  // @ts-ignore
  // eslint-disable-next-line react/no-unused-prop-types
  dateTimer: Moment | null;
  connectionInfo: any;
  nextJPDate: string;
  onShuffleClick: () => void;
  isShuffleDisabled: boolean;
  gameType: GameType;
}

export const Head = ({
  tableId,
  roundId = InfoPlaceholder,
  dealerName,
  isChangeDealerDisabled,
  onChangeDealerClick,
  onCloseTableClick,
  className,
  stage,
  dateTimer,
  connectionInfo,
  nextJPDate,
  onShuffleClick,
  isShuffleDisabled,
  gameType,
}: IProps) => (
  <Wrapper className={className}>
    <TableDescription>
      <Item hasNextJPDate={Boolean(nextJPDate)}>
        <ItemInner>
          <ItemLabel>Table ID</ItemLabel>
          <ItemValue>{tableId}</ItemValue>
        </ItemInner>
      </Item>
      <Item hasNextJPDate={Boolean(nextJPDate)}>
        <ItemInner>
          <ItemLabel>Game ID</ItemLabel>
          <ItemValue>{roundId}</ItemValue>
        </ItemInner>
      </Item>
      <Item hasNextJPDate={Boolean(nextJPDate)}>
        <ItemInner>
          <ItemLabel>Dealer</ItemLabel>
          <ItemValue>{dealerName}</ItemValue>
        </ItemInner>
        <UserButton
          disabled={isChangeDealerDisabled}
          onClick={onChangeDealerClick}
          iconName={IconNames.People}
        />
      </Item>
    </TableDescription>
    <ControlsWrapper>
      {gameType === GameType.CLASSIC_BAC && (
        <ShuffleButton onClick={onShuffleClick} disabled={isShuffleDisabled}>
          <Icon name={IconNames.Shuffle} />
          Shuffle
        </ShuffleButton>
      )}
      <ItemBox>
        <ItemInner>
          <ItemText>Connection type: {connectionInfo?.effectiveType}</ItemText>
          <ItemText>Ping (RTT): {connectionInfo?.rtt} ms</ItemText>
        </ItemInner>
      </ItemBox>
      {nextJPDate && <JPDate>Next JP: {nextJPDate}</JPDate>}
      {(stage || dateTimer) && (
        <StageCountdown>
          {stage && <StageText dominant-baseline="hanging">Stages ON</StageText>}
          {dateTimer && !stage && (
            <Countdown
              date={dateTimer?.toDate()}
              renderer={({ days, hours, minutes, seconds }) => (
                <StageText dominant-baseline="hanging">
                  {hours + days * 24 < 10 ? `0${hours}` : hours + days * 24} :{' '}
                  {minutes < 10 ? `0${minutes}` : minutes} :{' '}
                  {seconds < 10 ? `0${seconds}` : seconds}
                </StageText>
              )}
            />
          )}
        </StageCountdown>
      )}
      <Buttons>
        <PowerButton onClick={onCloseTableClick} iconName={IconNames.Power} />
      </Buttons>
    </ControlsWrapper>
  </Wrapper>
);
